import { render, staticRenderFns } from "./DatasetInfo.vue?vue&type=template&id=b1ff735a"
import script from "./DatasetInfo.vue?vue&type=script&lang=ts"
export * from "./DatasetInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports